import { CircularProgress, IconButton } from '@mui/material';
import type { IconButtonProps } from '@mui/material';

// use this component to wrap the icon in white border
type IconButtonWrapperProps = {
  tooltip?: string;
  isLoading?: boolean;
} & IconButtonProps;

const IconButtonWrapper = ({
  children,
  tooltip,
  isLoading = false,
  ...restProps
}: IconButtonWrapperProps) => {
  const { sx, ...rest } = restProps;

  return (
    <IconButton
      title={tooltip}
      sx={{
        width: '28px',
        height: '28px',
        padding: 0,
        border: (theme) => `1px solid ${theme.palette.borderColor}`,
        bgcolor: (theme) => theme.palette.common.white,
        borderRadius: '5px',
        '&:hover': {
          backgroundColor: '#ffffff',
        },
        margin: 1,
        ...sx,
      }}
      {...rest}
    >
      {isLoading ? <CircularProgress size={16} /> : children}
    </IconButton>
  );
};

export default IconButtonWrapper;
